export const AD_BIDDER_ATTEMPT = "AD_BIDDER_ATTEMPT";
export const AD_BIDDER_SUCCESS = "AD_BIDDER_SUCCESS";
export const AD_BIDDER_FAILED = "AD_BIDDER_FAILED";

export const AD_MOREBIDDER_ATTEMPT = "AD_MOREBIDDER_ATTEMPT";
export const AD_MOREBIDDER_SUCCESS = "AD_MOREBIDDER_SUCCESS";
export const AD_MOREBIDDER_FAILED = "AD_MOREBIDDER_FAILED";
export const LOGOUT = "LOGOUT";